import React, { HTMLAttributes, useCallback, useEffect, useRef } from 'react';

/**
 * @interface Base defintion of SkodaFlow ContentDiv component independent on core implementation.
 */
export interface ContentDivProps extends HTMLAttributes<HTMLDivElement> {
  setIsOverFlowing: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
  modalLoadedCallback?: (isLoaded: boolean) => void;
}

/**
 * @description SkodaFlow ContentDiv component
 * @param props ContentDivProps
 * @returns React Functional Component
 */
export const ContentDiv = ({ children, setIsOverFlowing, className, modalLoadedCallback }: ContentDivProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const scrollbarVisible = useCallback((element: HTMLDivElement | null) => {
    return !!element && element.scrollHeight > element.clientHeight;
  }, []);

  useEffect(() => {
    if (ref.current) setIsOverFlowing(scrollbarVisible(ref.current));
  }, [ref, scrollbarVisible, setIsOverFlowing]);

  useEffect(() => {
    modalLoadedCallback && modalLoadedCallback(true);

    return () => modalLoadedCallback && modalLoadedCallback(false);
  }, [modalLoadedCallback]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};
